import React,{useEffect} from "react";
import { useRecoilState } from "recoil";
import { AdminMenus } from "../../components/recoil/atoms/Menus";
import {LoginAfterCheckLogin} from "../../components/common/Common";
const MainAdmin = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검
  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //대시보드를 위한 정보 읽어오기
  const getAdminDashboardInformation = async () => {
/*     await axios.post(`${process.env.REACT_APP_HOST}/_get_admin_dashboard_information`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {

      }
    }); */
  }

  //최초실행부
  useEffect(() => {
    console.log(varAdminMenus);
    setAdminMenus({type:'',item:''});
    getAdminDashboardInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="admin_contents" className="adm_contents">
      <div className="tit">
        <div className="title">대시보드</div>
      </div>
      <div className="admin-content">

      </div>
    </div>
  );
}
export default MainAdmin;